import { FaGithub, FaLinkedin } from "react-icons/fa";
import SmoothScroll from "../scroll-to-top/SmoothScroll";

const headerData = [
  {
    name: "Tech",
    href: "#tech",
  },
  {
    name: "Experience",
    href: "#experience",
  },
  {
    name: "Projects",
    href: "#projects",
  },
  {
    name: "Contact",
    href: "#contact",
  },
];

const Header: React.FC = () => {
  return (
    <header className="sticky top-0 w-full bg-var(--header-bg) z-50 backdrop-blur-(--header-blur) text-white border-b border-white/10 h-16 flex items-center">
     <SmoothScroll/>
      <div className="container mx-auto flex justify-between ">
        <a href="/" className="font-inter font-medium text-md">
          Saurabh
        </a>
        <div className=" hidden lg:flex items-center gap-8">
          {headerData.map((data) => (
            <a
              key={data.name}
              href={data.href}
              className="text-sm text-gray-400 hover:text-white bg-none hover:bg-[#28282c] px-2 py-1 rounded-md transition-all ease-in-out duration-200"
            >
              {data.name}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-6">
          <a
            href="https://www.linkedin.com/in/saurabh-sharma-timilsina-848550270/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit LinkedIn Profile"
            className="hover:text-blue-600 transition duration-200"
          >
            <FaLinkedin className="w-5 h-5" />
          </a>
          <a
            href="https://github.com/Sauravify/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit GitHub Profile"
            className="hover:text-gray-400 transition duration-200"
          >
            <FaGithub className="w-5 h-5" />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
